import { FileWithPath } from '@mantine/dropzone';

import { Project } from '@/shared/config/projects';
import { axiosInstance } from '@/shared/core';
import { projectAxios } from '@/shared/core/axios';

import {
  CreateCategoryDTO,
  GetCategoriesResponseDTO,
  GetCategoryResponseDTO,
  UpdateCategoryDTO,
} from './dto/categories.dto';
import { uploadKitabaFile } from './upload';

export async function uploadCategoryPreview(
  project: Project,
  file: FileWithPath,
): Promise<string> {
  if (project === 'kitaba') {
    return (await uploadKitabaFile(file, 'categories', 'image')).path;
  }
  const formData = new FormData();

  formData.append('image', file);
  return (
    await axiosInstance.post<{ imagePath: string }>(
      '/book/uploadImage',
      formData,
    )
  ).data.imagePath;
}

export async function createCategory(
  project: Project,
  data: CreateCategoryDTO,
): Promise<void> {
  if (project === 'kitaba') {
    await projectAxios.kitaba.post('/categories', data);
    return;
  }
  await axiosInstance.post('/category/create', {
    title: data.title,
    imgUrl: data.imgUrl,
  });
}

export async function getCategory(
  project: Project,
  id: number,
): Promise<GetCategoryResponseDTO> {
  if (project === 'kitaba') {
    const category = (await projectAxios.kitaba.get(`/categories/${id}`)).data;
    return { ...category, language: '' };
  }
  return (
    await axiosInstance.get('/category/get', {
      params: {
        categoryId: id,
      },
    })
  ).data;
}

export async function getCategories(
  project: Project,
): Promise<GetCategoriesResponseDTO> {
  if (project === 'kitaba') {
    const response = (await projectAxios.kitaba.get('/categories')).data;
    return {
      categories: response.categories.map(
        (category: { id: number; title: string; imgUrl: string }) => ({
          ...category,
          language: '',
        }),
      ),
    };
  }
  return (await axiosInstance.get('/category/getAll')).data;
}

export async function updateCategory(
  project: Project,
  data: UpdateCategoryDTO,
): Promise<void> {
  if (project === 'kitaba') {
    await projectAxios.kitaba.patch(`/categories/${data.id}`, {
      title: data.title,
      ...(data.imgUrl && { imgUrl: data.imgUrl }),
    });
    return;
  }
  await axiosInstance.post('/category/update', {
    id: data.id,
    title: data.title,
    imgUrl: data.imgUrl,
  });
}

export async function deleteCategory(
  project: Project,
  id: number,
): Promise<void> {
  if (project === 'kitaba') {
    await projectAxios.kitaba.delete(`/categories/${id}`);
    return;
  }
  await axiosInstance.post('/category/delete', {
    id,
  });
}
